import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const communityCards = [
  {
    icon: 'ri-chat-smile-2-line',
    title: '穿搭交流群',
    desc: '每天分享OOTD，互相种草好看的单品，一起变美~',
    members: '3.2万',
  },
  {
    icon: 'ri-camera-line',
    title: '美妆分享圈',
    desc: '化妆技巧交流、新品测评、妆容打卡，美妆少女集合地',
    members: '2.8万',
  },
  {
    icon: 'ri-book-open-line',
    title: '手账同好会',
    desc: '手账排版灵感、文具安利、拼贴创作分享',
    members: '1.5万',
  },
  {
    icon: 'ri-cake-line',
    title: '烘焙小厨房',
    desc: '分享甜品食谱和烘焙作品，甜蜜治愈每一天',
    members: '1.2万',
  },
];

const NEWSLETTER_FORM_URL = 'https://readdy.ai/api/form/d9tauvjpv18futdmiap0';

export default function CommunitySection() {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const { ref, animated } = useScrollReveal();

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');

    if (!newsletterEmail.trim()) {
      setErrorMsg('请输入邮箱地址哦~');
      return;
    }

    const formEl = e.currentTarget as HTMLFormElement;
    const formData = new FormData(formEl);
    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setSubmitted(true);
      setNewsletterEmail('');
      return;
    }
    formData.delete('website_alt');

    try {
      const params = new URLSearchParams();
      formData.forEach((v, k) => {
        params.append(k, String(v));
      });

      const res = await fetch(NEWSLETTER_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const text = await res.text();
      if (res.ok) {
        setSubmitted(true);
        setNewsletterEmail('');
      } else {
        setErrorMsg('订阅出错了，请稍后再试~');
      }
    } catch {
      setErrorMsg('网络出错了，请稍后再试~');
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className={`text-center mb-10 md:mb-14 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{ transition: 'all 0.6s ease-out' }} ref={ref}>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            少女兴趣社群
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            加入志同道合的少女社群，和闺蜜们一起分享快乐与成长~
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14 stagger-children ${animated ? 'animated' : ''}`}>
          {communityCards.map((card) => (
            <div
              key={card.title}
              className="stagger-item bg-background-50 rounded-lg p-6 text-center cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${card.icon} text-2xl`}></i>
              </div>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-900">
                {card.title}
              </h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{card.desc}</p>
              <span className="inline-block mt-4 text-xs text-primary-600 bg-primary-50 px-3 py-1 rounded-full font-medium">
                {card.members} 成员
              </span>
            </div>
          ))}
        </div>

        <div className="max-w-lg mx-auto bg-accent-500 rounded-lg p-8 text-center">
          <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-white/20 text-white">
            <i className="ri-mail-send-line text-xl"></i>
          </div>
          {submitted ? (
            <div className="mt-4">
              <h3 className="text-lg font-heading font-bold text-white">订阅成功！</h3>
              <p className="mt-2 text-sm text-white/80">
                感谢订阅少女日报，每周将为你送达精选内容~
              </p>
            </div>
          ) : (
            <>
              <h3 className="mt-4 text-lg font-heading font-bold text-white">
                订阅少女日报
              </h3>
              <p className="mt-2 text-sm text-white/80">
                每周精选少女穿搭、美妆、好物内容，让你的少女心永不掉线~
              </p>
              <form className="mt-6" onSubmit={handleNewsletter} id="newsletter-home" data-readdy-form="true">
                <div className="website-alt-wrapper">
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                </div>
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="email"
                    name="email"
                    value={newsletterEmail}
                    onChange={(e) => setNewsletterEmail(e.target.value)}
                    placeholder="输入你的邮箱地址"
                    className="flex-1 px-4 py-2.5 rounded-lg text-sm bg-white/20 border border-white/30 text-white placeholder:text-white/50 focus:outline-none focus:border-white/60 transition-colors"
                    required
                  />
                  <button
                    type="submit"
                    className="px-6 py-2.5 rounded-lg text-sm font-medium bg-white text-accent-600 hover:bg-white/90 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    立即订阅
                  </button>
                </div>
                {errorMsg && (
                  <p className="mt-2 text-xs text-white/80">{errorMsg}</p>
                )}
              </form>
            </>
          )}
        </div>
      </div>
    </section>
  );
}